export const module = {
  info: {
    name: 'jikatel-dialplan-upload-document',
    caption: 'Jikatel Dialplan Upload  Document'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  sideMenu: {
    caption: 'Jikatel Dialplan Document',
    icon: 'el-icon-edit-outline',
    routeName: 'module->jikatel-dialplan-upload-document->panel',
  }
}

export default module
